import { validatePassword } from '@utils';
import { FormFields } from 'hooks';

export type OrderConfirmationFormFieldNames = 'password';

export const formFields: FormFields<OrderConfirmationFormFieldNames> = {
  password: {
    name: 'password',
    initialValue: '',
    isRequired: true,
    validate: validatePassword,
    requiredMessage: 'Password is required'
  }
};
